import * as React from 'react'

import AnchorPointsDesktop from '../../components/AnchorPointsDesktop/AnchorPointsDesktop'
import AnchorPointsMobile from '../../components/AnchorPointsMobile/AnchorPointsMobile'
import Viewport from '../../components/Viewport/Viewport'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import styles from './anchorPoints-style.css'
type Props = {
  anchorPoints: Array<LinkViewModel>
  mobileTitle: string
}
type State = {}

class AnchorPoints extends React.Component<Props, State> {
  static displayName = 'AnchorPoints'
  static defaultProps = {}

  render() {
    const { anchorPoints, mobileTitle } = this.props

    return (
      <div className={styles.anchorPoints}>
        <div className={styles.anchorPointsComp}>
          <Viewport>
            {({ isDesktop }) =>
              isDesktop ? (
                <AnchorPointsDesktop anchorPoints={anchorPoints} isDesktop={isDesktop} />
              ) : (
                <AnchorPointsMobile
                  anchorPoints={anchorPoints}
                  isDesktop={isDesktop}
                  mobileTitle={mobileTitle}
                />
              )
            }
          </Viewport>
        </div>
      </div>
    )
  }
}

export default AnchorPoints